export default __webpack_public_path__ + "static/media/electrolytedrink@3x.209c3d56.jpg";